/* eslint-disable no-useless-catch */
import { serialize } from '../utils';
import { FindOneOptions, FindOptions } from './common';
import { entityService } from './services';
// #endregion Local Imports

const pathname = '/co-buy-products';

export const CoBuyProductApi = {
  find: async (option: FindOptions) => {
    let url = pathname;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  create: async (body: any) => {
    try {
      const response = await entityService.post(pathname, body);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  createMulti: async (body: any) => {
    try {
      const response = await entityService.post(`${pathname}/multi`, body);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  findOne: async (id: string, option: FindOneOptions) => {
    let url = `${pathname}/${id}`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  update: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateStatus: async (id: string, body: UpdateCoBuyProductStatus) => {
    const url = `${pathname}/update-status/${id}`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  remove: async (id: string) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.delete(url);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  createPromotion: async (coBuyProductId: string, body: any = {}) => {
    const url = `${pathname}/${coBuyProductId}/promotion`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  updatePromotion: async (
    coBuyProductId: string,
    coBuyPromotionId: string,
    body: any = {}
  ) => {
    const url = `${pathname}/${coBuyProductId}/promotion/${coBuyPromotionId}`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  deletePromotion: async (coBuyProductId: string, coBuyPromotionId: string) => {
    const url = `${pathname}/${coBuyProductId}/promotion/${coBuyPromotionId}`;

    try {
      const response = await entityService.delete(url);
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export interface UpdateCoBuyProductStatus {
  status: number;
}
